module.exports = __webpack_public_path__ + "img/img_empty_result.9f3ff22b.png";